/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface OtherMedicalSystemDto
 */
export interface OtherMedicalSystemDto {
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof OtherMedicalSystemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMedicalSystemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMedicalSystemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMedicalSystemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMedicalSystemDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof OtherMedicalSystemDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof OtherMedicalSystemDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherMedicalSystemDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherMedicalSystemDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherMedicalSystemDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof OtherMedicalSystemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof OtherMedicalSystemDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMedicalSystemDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof OtherMedicalSystemDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMedicalSystemDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMedicalSystemDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof OtherMedicalSystemDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof OtherMedicalSystemDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMedicalSystemDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    typeId?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof OtherMedicalSystemDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {StateOfUse}
     * @memberof OtherMedicalSystemDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    trackItAlias?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMedicalSystemDto
     */
    $type?: OtherMedicalSystemDtoTypeEnum;
}


/**
 * @export
 */
export const OtherMedicalSystemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsOtherMedicalSystemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type OtherMedicalSystemDtoTypeEnum = typeof OtherMedicalSystemDtoTypeEnum[keyof typeof OtherMedicalSystemDtoTypeEnum];



/**
 * Check if a given object implements the OtherMedicalSystemDto interface.
 */
export function instanceOfOtherMedicalSystemDto(value?: unknown): value is OtherMedicalSystemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(OtherMedicalSystemDtoTypeEnum)[0];
}

export function OtherMedicalSystemDtoFromJSON(json: any): OtherMedicalSystemDto {
    return OtherMedicalSystemDtoFromJSONTyped(json, false);
}

export function OtherMedicalSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherMedicalSystemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'typeId': json['typeId'] == null ? undefined : json['typeId'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'trackItAlias': json['trackItAlias'] == null ? undefined : json['trackItAlias'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function OtherMedicalSystemDtoToJSON(value?: Omit<OtherMedicalSystemDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'|'deleterUserId'|'deletionTime'|'isDeleted'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'typeSpecification': value['typeSpecification'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isArchived': value['isArchived'],
        'defaultImageId': value['defaultImageId'],
        'typeId': value['typeId'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'state': StateOfUseToJSON(value['state']),
        'trackItAlias': value['trackItAlias'],
        'serialNumber': value['serialNumber'],
        '$type': value['$type'],
    });
}

